import ApiClient from "@/domain/core/utils/apiClient";
import client_core from "@/services/clients/client_core";
const client = new ApiClient(client_core)

const endpoints = {
    list: '/dashboard/v2/event-wizard/{pk}/tag-definitions/',
    detail: '/dashboard/v2/event-wizard/{pk}/tag-definitions/{id}/',
}

export default {
    async fetchTagDefinitions(picaServiceId, filters, pagination, sorting) {
        const url = endpoints.list.replace('{pk}', picaServiceId)
        const result = await client.get(url, {
            ...filters,
            page_size: pagination.page_size ?? 20,
            page: pagination.page ?? 1,
            ordering: sorting.asc ? `-${sorting.column}` : sorting.column ?? '',
        })
        return {
            results: result.results,
            pagination: {
                num_pages: Math.ceil(result.count / (pagination.page_size ?? 20)),
                page_size: pagination.page_size ?? 20,
                page: pagination.page ?? 1,
                total: result.count,
            }
        }
    },

    async fetchTagDefinition(picaServiceId, id) {
        const url = endpoints.detail
            .replace('{pk}', picaServiceId)
            .replace('{id}', id)
        return await client.get(url)
    },

    async createTagDefinition(picaServiceId, data) {
        const url = endpoints.list.replace('{pk}', picaServiceId)
        return await client.post(url, data)
    },

    async updateTagDefinition(picaServiceId, id, data) {
        const url = endpoints.detail
            .replace('{pk}', picaServiceId)
            .replace('{id}', id)
        return await client.patch(url, data)
    },

    async deleteTagDefinition(picaServiceId, id) {
        const url = endpoints.detail
            .replace('{pk}', picaServiceId)
            .replace('{id}', id)
        await client.delete(url)
    },
}
